<div class="tw-absolute tw-z-200 tw-w-96 tw-right-5">
  <div class="tw-fixed tw-w-96">
    @if( !suppressNotifications ) {
    <app-notification
      *ngFor="let notification of notifications$ | async"
      [notification]="notification"
      [playAudioAlerts]="playAudioAlerts"
      (startRingTone)="startRingTone()"
      (endRingTone)="endRingTone()"
      (dismiss)="dismiss($event)">
    </app-notification>
    }
  </div>
</div>
